// 活動內容頁
'use client';
import EventsActivityContent from '@/components/events/EventsActivityContent';
import Link from 'next/link';
import EventsActivitySpeakers from './EventsActivitySpeakers';
import { useTranslation } from 'react-i18next';
import EventsActivityBanner from './EventsActivityBanner';

const EventsActivity = ({ event }) => {
    const { t } = useTranslation();

    return (
        <div className="w-full pb-[65px] pt-[24px] blg:pt-[10px] bmd:pt-[10px] bsm:pt-[15px] uxs:pt-[10px]">
            <EventsActivityBanner
                img={event?.imageFb || event?.image}
                title={event?.title}
                place={event?.place}
                beginTime={event?.beginTime}
                progressStatus={Number(event?.progressStatus)}
                labels={event?.label}
                link={event?.link}
            />
            <EventsActivityContent content={event?.rule} />

            {event?.speakers && event?.speakers.length > 0 ? (
                <EventsActivitySpeakers content={event?.speakers} t={t} />
            ) : (
                ''
            )}

            {(event?.code === 'spin' || event?.code === 'lottery') && (
                <div className="px-[30px] umd:px-0">
                    <a
                        href={`/campaign/${event?.code}${
                            event?.code === 'spin' ? '/' + event?.slug : ''
                        }`}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="bg-[#29AFCB] text-btn1 text-center text-[#fff] py-[15px] rounded-[40px] w-full block trans hover:bg-[#005771]"
                    >
                        {t('JOIN')}
                    </a>
                </div>
            )}

            <div className="return w-full mt-[45px] umd:mt-[35px] usm:mt-[25px]">
                <Link href="/events">{t('BACK')}</Link>
            </div>
        </div>
    );
};

export default EventsActivity;
